import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { ReactComponent as FemaleIcon } from "../../../../assets/img/icon/female_black_24dp.svg";
import { ReactComponent as MaleIcon } from "../../../../assets/img/icon/male_black_24dp.svg";

const CardPatient = ({ patient, className }) => {
  const history = useHistory();
  const handleClick = () => {
    history.push(`/patient/${patient._id}`);
  };

  if (patient._id === undefined)
    return (
      <div
        className={`${className} cursor-pointer px-2 md:px-4 py-2.5 border border-primary shadow-lg rounded-lg w-full animate-pulse flex space-x-2`}
      >
        <div className="rounded-full bg-primary h-12 w-12"></div>
        <div className="flex-1 space-y-2 py-1">
          <div className="h-4 bg-primary rounded w-5/6"></div>
          <div className="h-4 bg-primary rounded"></div>
        </div>
      </div>
    );

  return (
    <div
      className={`${className} cursor-pointer px-2 md:px-4 py-2.5 border border-primary shadow-lg rounded-lg hover:bg-secondary hover:bg-opacity-20`}
      onClick={handleClick}
    >
      <div className="flex space-x-2 md:space-x-4 items-center relative">
        <div className="w-12 h-12 bg-secondary flex-shrink-0 rounded-full text-center">
          <span
            className=" text-white text-xl md:text-2xl uppercase"
            style={{ lineHeight: "3rem" }}
          >
            {patient.initial}
          </span>
        </div>
        <div className="">
          <div className="text-base md:text-lg font-medium">{patient.name}</div>
          <div className="mt-0.5 md:mt-0 text-xs md:text-sm text-gray-800 text-opacity-50 ">
            {patient.profile.age ? `${patient.profile.age} Tahun |` : ""}
            {`
             ${patient.profile.weight || "-"} Kg |
             ${patient.profile.height || "-"} cm`}
          </div>
        </div>
        {patient.profile.isMale === true && (
          <div className="absolute right-0">
            <MaleIcon className="w-10 h-10 fill-current text-gray-500 text-opacity-50" />
          </div>
        )}
        {patient.profile.isMale === false && (
          <div className="absolute right-0">
            <FemaleIcon className="w-10 h-10 fill-current text-gray-500 text-opacity-50" />
          </div>
        )}
      </div>
    </div>
  );
};

CardPatient.propTypes = {
  className: PropTypes.string,
  patient: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.exact({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      initial: PropTypes.string.isRequired,
      profile: PropTypes.exact({
        age: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dateOfBirth: PropTypes.string,
        height: PropTypes.number,
        isMale: PropTypes.bool,
        weight: PropTypes.number,
      }),
    }).isRequired,
  ]),
};

export default CardPatient;
